
import React from 'react';
import { Clock, Scale, DollarSign } from "lucide-react";

export const KeyFindings: React.FC = () => {
  return (
    <section className="mb-16 bg-white/5 backdrop-blur-sm p-8 rounded-xl">
      <h2 className="text-2xl md:text-3xl font-bold mb-6">Key Findings</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div className="flex gap-3">
          <div className="bg-blue-600/20 p-3 rounded-lg h-fit">
            <Clock className="h-6 w-6 text-blue-400" />
          </div>
          <div>
            <h3 className="font-bold text-lg mb-2">Time Savings</h3>
            <p className="text-white/80">1-2 hours saved daily per attorney</p>
          </div>
        </div>
        
        <div className="flex gap-3">
          <div className="bg-blue-600/20 p-3 rounded-lg h-fit">
            <Scale className="h-6 w-6 text-blue-400" />
          </div>
          <div>
            <h3 className="font-bold text-lg mb-2">Client Experience</h3>
            <p className="text-white/80">Enhanced service with faster turnaround</p>
          </div>
        </div>
        
        <div className="flex gap-3">
          <div className="bg-blue-600/20 p-3 rounded-lg h-fit">
            <DollarSign className="h-6 w-6 text-blue-400" />
          </div>
          <div>
            <h3 className="font-bold text-lg mb-2">ROI</h3>
            <p className="text-white/80">Clear financial returns within months</p>
          </div>
        </div>
      </div>
      
      <div className="text-center mt-8">
        <p className="text-lg text-white/80 italic">
          "These case studies prove that with the right AI strategy, small firms can now compete 
          with larger practices on a level playing field..."
        </p>
        <p className="mt-2">Download the full report to read more</p>
      </div>
    </section>
  );
};

export default KeyFindings;
